import { useDispatch } from "react-redux";
import { setShowNav } from "../redux/actions";
import { NAV_STATES } from "../system/constants";

import { getPagePos } from "../system/coords";

// Content
import HomeContent from "../content/Home";
import AboutContent from "../content/About";
import ClientsContent from "../content/Clients";
import TechContent from "../content/Tech";
import ShowcaseContent from "../content/Showcase";
import DemosContent from "../content/Demos";
import ContactContent from "../content/Contact";

const Page = ({ left, top, width, height, content }) => {
  const stylesObj = {
    left: `${left}px`,
    top: `${top}px`,
    width: `${width}px`,
    height: `${height}px`,
  };

  return (
    <>
      <div className="Page" style={stylesObj}>
        {content}
      </div>
    </>
  );
};

// Helper to create a page component with positioning
const createPageComponent = (pageName, ContentComponent) => {
  const PageComponent = ({ width, height }) => {
    const [posX, posY] = getPagePos(pageName);

    return (
      <Page
        left={Math.round(width * posX)}
        top={Math.round(height * posY)}
        width={width}
        height={height}
        content={<ContentComponent />}
      />
    );
  };

  PageComponent.displayName = `Page(${pageName})`;
  return PageComponent;
};

// Generate the pages
const Home = createPageComponent("Home", HomeContent);
const About = createPageComponent("About", AboutContent);
const Clients = createPageComponent("Clients", ClientsContent);
const Tech = createPageComponent("Tech", TechContent);
const Showcase = createPageComponent("Showcase", ShowcaseContent);
const Demos = createPageComponent("Demos", DemosContent);
const Contact = createPageComponent("Contact", ContactContent);

// Nav
const MainContent = ({ width, height }) => {
  const dispatch = useDispatch();
  const visState = NAV_STATES.HIDE;

  return (
    <>
      <main
        className="Main center full-height"
        onMouseEnter={() => {
          dispatch(setShowNav(visState));
        }}
      >
        <Home width={width} height={height} />
        <About width={width} height={height} />
        <Clients width={width} height={height} />
        <Tech width={width} height={height} />
        <Showcase width={width} height={height} />
        <Demos width={width} height={height} />
        <Contact width={width} height={height} />
      </main>
    </>
  );
};

export default MainContent;
